<template>
  <div style="padding-left: 3%; padding-right: 3%; background-color: #F8F9FA;" class="rolemanage-edit">
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          แก้ไขสิทธิ์การใช้งาน
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <v-btn width="18%" class="button-color-outline ma-0" outlined dark @click="goBack()">ยกเลิก</v-btn>
        <!-- <v-btn width="18%" class="ma-2 mr-5" color="#3776E9" dark @click="submitData()">บันทึกข้อมูล</v-btn> -->
        <v-btn width="18%" class="button-color ma-2 mr-2" dark @click="dialogConfirm = true">บันทึกข้อมูล</v-btn>
      </v-col>
    </v-row>
    <div style="background-color: #fff; max-height: auto;" class="pt-1">
      <div>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
        <v-row class="pa-5">
          <v-col cols="8">
            <span class="ra-head-text-bold">ข้อมูลสิทธิ์การใช้งาน</span>
          </v-col>
          <v-col cols="12" class="text-center mx-0">
            <v-divider
            ></v-divider>
          </v-col>
          <v-col cols="3" class="form-control" style="margin-top: 0%;">
            <!-- <span class="txt-font">ประเภทสิทธิ์การใช้งาน *</span> -->
            <span class="txt-font" style="color: grey; font-size: 14px;">ประเภทสิทธิ์การใช้งาน</span><span class="ml-1"></span><span style="color: red;">*</span>
            <v-select
              v-model="roleType"
              :items="itemRoleType"
              item-text="name"
              item-value="_id"
              label="เลือกประเภทสิทธิ์การใช้งาน"
              :rules="inputRules"
              color="#333"
              outlined
              disabled
              dense
            >
              <template v-slot:selection="">
              </template>
              <template slot="selection" slot-scope="{ item }">
                <span>{{item.name}}</span>
              </template>
              <!-- <template slot="item" slot-scope="{ item }">
                <v-list-tile-content>
                  <v-list-tile-title>{{item}}</v-list-tile-title>
                </v-list-tile-content>
              </template> -->
            </v-select>
          </v-col>
          <v-col cols="4" class="form-control">
            <!-- <span class="txt-font">ชื่อสิทธิ์การใช้งาน</span> -->
            <span class="txt-font" style="color: grey; font-size: 14px;">ชื่อสิทธิ์การใช้งาน</span><span class="ml-1"></span><span style="color: red;">*</span>
            <v-text-field
              v-model="roleName"
              label="ระบุชื่อสิทธิ์การใช้งาน"
              :rules="inputRules"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="form-control">
            <!-- <span class="txt-font">รายละเอียดสิทธิ์การใช้งาน</span> -->
            <span class="txt-font" style="color: grey; font-size: 14px;">รายละเอียดสิทธิ์การใช้งาน</span>
            <v-text-field
              v-model="roleDescription"
              label="ระบุรายละเอียดสิทธิ์การใช้งาน"
              :rules="inputRules"
              dense
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        </v-form>
        <v-row class="mt-5 pl-4" justify=start>
          <v-col cols="8">
            <span class="ra-head-text-bold">กำหนดสิทธิ์การใช้งาน</span>
          </v-col>
          <v-col cols="12" class="mx-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <!-- <h2 class="txt-head mb-3" style="text-decoration: underline">
          กำหนดสิทธิ์การใช้งาน
        </h2> -->
        <OverlayLoading :loading="loading" />
        <div>
          <v-row style="background-color: #F8F9FB; margin-top: 0%; border-color: red;" class="pa-0 ma-0 elevation-2">
            <v-col cols="3" xl="2" lg="3" class="text-left">
              <span class="txt-header-sup ml-10">รายการ</span>
            </v-col>
            <v-col cols="" class="text-center mx-0" style="position: static;">
              <span class="txt-header-sup">ดู</span>
            </v-col>
            <v-col cols="" class="text-center">
              <span class="txt-header-sup">สร้าง</span>
            </v-col>
            <v-col cols="" class="text-center">
              <span class="txt-header-sup">แก้ไข</span>
            </v-col>
            <v-col cols="" class="text-center">
              <span class="txt-header-sup">ลบ</span>
            </v-col>
            <v-col cols="" class="text-center">
              <span class="txt-header-sup">อัปโหลด</span>
            </v-col>
            <v-col cols="" class="text-center mx-2">
              <span class="txt-header-sup">ดาวน์โหลด</span>
            </v-col>
            <v-col cols="2">
            </v-col>
          </v-row>
          <v-data-table
            :items="ob"
            class="border-table-employee text-no-wrap mt-0"
            group-by="name"
            group-key="_id"
            group-expanded
            hide-default-footer
            :expanded.sync="expanded"
            :loading="loading"
            loading-text="Loading... Please wait"
            :footer-props="{
              'items-per-page-options': [15, 30, 50, 100, -1],
              'items-per-page': 15
            }"
            disable-sort
          >
            <template v-slot:[`item.no`]="{ item }">
              {{ (perPage*(page-1)) + ob.indexOf(item)+1 }}
            </template>
            <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen, items }">
              <!-- {{ob.indexOf(items[0])+1}} {{items[0].selectAll}} -->
              <!-- <div class="row" style=""> -->
                <tr style="margin-left: 0%;">
                  <td :colspan="headers.length" :style="$vuetify.breakpoint.name === 'lg' ? 'width: 88.7%;' : 'width: 92.5%;'">
                    <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                        <v-icon color="#2BA197" v-if="isOpen">mdi-chevron-up</v-icon>
                        <v-icon color="#2BA197" v-else>mdi-chevron-down</v-icon>
                    </v-btn>
                    <span style="color: #053075; font-weight: normal;">{{ group }}</span>
                </td>
                <td align="">
                  <v-checkbox
                    v-model="items[0].selectAll"
                    color="#2BA197"
                    label="เลือกทั้งหมด"
                    class="txt-head"
                    @change="selectAll(items[0].selectAll, ob.indexOf(items[0]))"
                  ></v-checkbox>
                </td>
                </tr>
              <!-- </div> -->
            </template>
            <template v-slot:[`item`]="{ item }">
              <div class="row" >
                <v-simple-table class="" style="width:100%; border-radius: 0px; background-color: #FFFFFF;">
                  <template v-slot:default>
                    <tbody style="overflow-y: hidden!important; overflow-x: hidden!important;">
                      <tr v-for="(other, j) in item.children" :key="j">
                        <v-divider></v-divider>
                        <v-row class="ml-12 mb-2" style="height: 50px;">
                          <!-- :cols="$vuetify.breakpoint.name === 'xl' ? 2 : $vuetify.breakpoint.name === 'lg' ? 3 : 3 -->
                          <v-col cols="3" xl="2" lg="3" class="text-left">
                            <p class="mt-2" style="font-size: 14px;">{{other.text}}</p>
                          </v-col>
                          <v-col cols="" :class="$vuetify.breakpoint.name === 'xl' ? 'ml-6' : $vuetify.breakpoint.name === 'lg' ? 'ml-0' : 'ml-6'" style="height: 10px; margin-top: -1%;">
                            <v-checkbox
                              v-model="other.read"
                              label=""
                              color="#2BA197"
                              :readonly="other.readOnly === true"
                              @change="checkDefaultRead(j, ob.indexOf(item), item.selectAll),setSelectAll(item)"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="" class="form-control" style="margin-top: -1%;">
                            <v-checkbox
                              v-model="other.create"
                              label=""
                              color="#2BA197"
                              :disabled="!other.text?.includes('จัดการโครงสร้างงาน')"
                              :indeterminate="!other.text?.includes('จัดการโครงสร้างงาน') && (other.create === false || other.create === true || other.create === '' || other.selectAll === true || other.selectAll === false)"
                              @change="checkDefaultRead(j, ob.indexOf(item), item.selectAll),setSelectAll(item)"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="" class="form-control" style="margin-top: -1%;">
                            <v-checkbox
                              v-model="other.edit"
                              label=""
                              color="#2BA197"
                              :disabled="!other.text?.includes('จัดการโครงสร้างงาน')"
                              :indeterminate="!other.text?.includes('จัดการโครงสร้างงาน') && (other.edit === false || other.edit === true || other.edit === '' || other.selectAll === true || other.selectAll === false)"
                              @change="checkDefaultRead(j, ob.indexOf(item), item.selectAll),setSelectAll(item)"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="" class="form-control" style="margin-top: -1%;">
                            <v-checkbox
                              v-model="other.delete"
                              label=""
                              color="#2BA197"
                              :disabled="!other.text?.includes('จัดการโครงสร้างงาน')"
                              :indeterminate="!other.text?.includes('จัดการโครงสร้างงาน') && (other.delete === false || other.delete === true || other.delete === '' || other.selectAll === true || other.selectAll === false)"
                              @change="checkDefaultRead(j, ob.indexOf(item), item.selectAll),setSelectAll(item)"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="" class="form-control" style="margin-top: -1%;">
                            <v-checkbox
                              v-model="other.upload"
                              label=""
                              color="#2BA197"
                              :disabled="!other.text?.includes('จัดการโครงสร้างงาน')"
                              :indeterminate="!other.text?.includes('จัดการโครงสร้างงาน') && (other.upload === false || other.upload === true || other.upload === '' || other.selectAll === true || other.selectAll === false)"
                              @change="checkDefaultRead(j, ob.indexOf(item), item.selectAll),setSelectAll(item)"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="" class="form-control" style="margin-top: -1%;">
                            <v-checkbox
                              v-model="other.download"
                              label=""
                              color="#2BA197"
                              :disabled="!other.text?.includes('จัดการโครงสร้างงาน')"
                              :indeterminate="!other.text?.includes('จัดการโครงสร้างงาน') && (other.download === false || other.download === true || other.download === '' || other.selectAll === true || other.selectAll === false)"
                              @change="checkDefaultRead(j, ob.indexOf(item), item.selectAll),setSelectAll(item)"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="2">
                          </v-col>
                        </v-row>
                      </tr>
                    </tbody>
                  </template>
              </v-simple-table>
            </div>
            </template>
          </v-data-table>
        </div>
        <v-dialog v-model="dialogConfirm" max-width="500px">
          <v-card height="170px">
            <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการบันทึกข้อมูลนี้ ใช่หรือไม่?</v-card-title>
            <v-card-text class="justify-center text-center">
            <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการบันทึกข้อมูลนี้</span>
            </v-card-text>
            <v-card-actions class="">
              <v-spacer></v-spacer>
              <v-btn class="button-color-outline" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
              <v-btn class="button-color" dark @click="submitData()">ยืนยัน</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
      </div>
    </div>
  </div>
</template>

<script>
import
{
  getlistDataMenuById,
  getListRole,
  editRole
} from '@/API/API'
import { OverlayLoading } from '@/components/index'
import swal from 'sweetalert'

export default {
  name: 'create-new-department',
  components: {
    OverlayLoading
  },
  data () {
    return {
      expanded: [],
      dialogConfirm: false,
      singleExpand: true,
      tokenUser: '',
      loading: true,
      panel: [0, 1],
      panelTest: [0, 0],
      readonly: false,
      roleType: '',
      roleName: '',
      roleDescription: '',
      itemRoleType: [],
      permissionId: '',
      chkOrg: {
        checkRead: true,
        checkDel: true
      },
      chkEmployee: {
        name: '',
        checkRead: true,
        checkDel: true
      },
      checkPermission: [],
      headers: [
        { text: 'สายงานบังคับบัญชา', value: 'children' }
      ],
      ob: [],
      valid: true,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      checkPermissionTest: [{
        name: 'บริษัท',
        read: false,
        create: false,
        edit: false,
        delete: false
      }
      ],
      alertText: {
        'roleName is already': 'มีสิทธิ์การใช้งานนี้ในระบบแล้ว',
        'permission denied': 'ไม่ได้รับอนุญาตให้เพิ่มสิทธิ์การใช้งาน'
      }
    }
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    if (!this.$route.params.id) this.$router.go(-1)
    if (this.$route.params.id) {
      this.propsRoleId = this.$route.params.id
      console.log('Id', this.propsRoleId)
    }
    this.getListRole()
    this.getlistDataMenuById()
  },
  watch: {
    // ob: {
    //   handler: function (newValue) {
    //     if (newValue.selectAll) {
    //       console.log('OBBBBB')
    //     }
    //   }
    // }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    setSelectAll (data) {
      data.selectAll = true
      data.children.map(c => {
        // read create edit delete
        data.selectAll = data.selectAll && [c.read, c.create, c.edit, c.delete, c.upload, c.download].every((u) => { return u === '' ? true : !!u })
      })
    },
    selectAll (val, i) {
      for (let index = 0; index < this.ob.length; index++) {
        // console.log('check box all', this.ob[i].children)
        for (let j = 0; j < this.ob[i].children.length; j++) {
          // console.log('checkbox level 2', this.ob[i].chi-ldren[j].text)
          if (val === true) {
            if (this.ob[i].children[j].read !== '') {
              this.ob[i].children[j].read = true
            }
            if ((this.ob[i].children[j].create !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) || (this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน') && this.ob[i].children[j].create === '')) {
              this.ob[i].children[j].create = true
              this.ob[i].children[j].readOnly = true
            }
            if ((this.ob[i].children[j].edit !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) || (this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน') && this.ob[i].children[j].edit === '')) {
              this.ob[i].children[j].edit = true
              this.ob[i].children[j].readOnly = true
            }
            if ((this.ob[i].children[j].delete !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) || (this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน') && this.ob[i].children[j].delete === '')) {
              this.ob[i].children[j].delete = true
              this.ob[i].children[j].readOnly = true
            }
            if ((this.ob[i].children[j].upload !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) || (this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน') && this.ob[i].children[j].upload === '')) {
              this.ob[i].children[j].upload = true
              this.ob[i].children[j].readOnly = true
            }
            if ((this.ob[i].children[j].download !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) || (this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน') && this.ob[i].children[j].download === '')) {
              this.ob[i].children[j].download = true
              this.ob[i].children[j].readOnly = true
            }
          } else {
            if (this.ob[i].children[j].read !== '') {
              this.ob[i].children[j].read = false
            }
            if (this.ob[i].children[j].create !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) {
              this.ob[i].children[j].create = false
              this.ob[i].children[j].readOnly = true
            }
            if (this.ob[i].children[j].edit !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) {
              this.ob[i].children[j].edit = false
              this.ob[i].children[j].readOnly = true
            }
            if (this.ob[i].children[j].delete !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) {
              this.ob[i].children[j].delete = false
              this.ob[i].children[j].readOnly = true
            }
            if (this.ob[i].children[j].upload !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) {
              this.ob[i].children[j].upload = false
              this.ob[i].children[j].readOnly = true
            }
            if (this.ob[i].children[j].download !== '' && this.ob[i].children[j].text?.includes('จัดการโครงสร้างงาน')) {
              this.ob[i].children[j].download = false
              this.ob[i].children[j].readOnly = true
            }
          }
        }
      }
    },
    checkDefaultRead (j, i, chkAll) {
      console.log('i', i)
      for (let index = 0; index < this.ob.length - 1; index++) {
        for (let j = 0; j < this.ob[index].children.length; j++) {
          if (this.ob[index].children[j].create === true || this.ob[index].children[j].edit === true || this.ob[index].children[j].delete === true || this.ob[index].children[j].upload === true || this.ob[index].children[j].download === true) {
            this.ob[index].children[j].read = true
            this.ob[index].children[j].readOnly = true
          } else if (this.ob[index].children[j].create === false || this.ob[index].children[j].edit === false || this.ob[index].children[j].delete === false || this.ob[index].children[j].upload === false || this.ob[index].children[j].download === false) {
            // this.ob[index].children[j].read = false
            this.ob[index].children[j].readOnly = false
            this.ob[i].selectAll = false
          } else if (this.ob[index].children[j].read === true) {
            this.ob[index].children[j].read = true
          }
        }
      }
    },
    async getListRole () {
      // const tempTest = []
      const obj = {
        permissionTypeId: []
      }
      try {
        const res = await getListRole(obj, this.tokenUser)
        if (res.success) {
          // this.ob = res.result
          this.itemRoleType = res.result.permissionsType
        } else {
          console.log(res)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getlistDataMenuById () {
      // const tempTest = []
      const obj = {
        id: this.propsRoleId
      }
      try {
        const res = await getlistDataMenuById(obj, this.tokenUser)
        console.log('🚀 ~ file: update.vue ~ line 455 ~ getlistDataMenuById ~ res', res)
        if (res.success) {
          this.permissionId = res.result._id
          this.ob = res.result.permissiom
          this.roleType = res.result.type._id
          this.roleName = res.result.type.name
          this.roleDescription = res.result.comment
          for (let index = 0; index < this.ob.length; index++) {
            if (this.ob[index].selectAll === true) {
              this.selectAll(this.ob[index].selectAll, this.ob.indexOf(this.ob[index]))
            }
          }
          this.loading = false
        } else {
          console.log(res)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async submitData () {
      console.log('SubmitData', this.ob)
      // var subChildren = []
      // console.log('checkReadOrg', this.checkboxReadOrg)
      for (let index = 0; index < this.ob.length; index++) {
        // console.log('check data Name', this.ob[index].name)
        // console.log('check data', this.ob[index].children)
        for (let j = 0; j < this.ob[index].children.length; j++) {
          this.checkPermission.push({
            name: this.ob[index].children[j].name,
            read: this.ob[index].children[j].read,
            create: this.ob[index].children[j].create,
            edit: this.ob[index].children[j].edit,
            delete: this.ob[index].children[j].delete,
            upload: this.ob[index].children[j].upload,
            download: this.ob[index].children[j].download,
            _id: this.ob[index].children[j]._id
          })
        }
      }
      const obj = {
        id: this.permissionId,
        typeId: this.propsRoleId,
        name: this.roleName,
        comment: this.roleDescription,
        permission: this.checkPermission
      }
      try {
        const res = await editRole(obj, this.tokenUser)
        if (res.success) {
          swal('สำเร็จ', 'แก้ไขกำหนดสิทธิ์การใช้งานสำเร็จ', 'success', {
            button: false,
            timer: 2000
          })
          this.dialogConfirm = false
          this.loading = false
          // this.checkPermission = []
          this.$router.go(-1)
        } else {
          swal('ผิดพลาด', `${this.alertText[res.data.msg] || ''} กรุณาลองใหม่อีกครั้ง`, 'error', {
            button: false,
            timer: 2000
          })
          this.dialogConfirm = false
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.dialogConfirm = false
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.round1 {
  border: 1px solid rgb(165, 163, 163);
  border-radius: 5px;
}
.right {
  margin: auto;
  width: 60%;
  border: 3px solid #73AD21;
  padding: 10px;
}
.head-expand {
  background-color: #C5E1A5 ;
}
.box-tooltip {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  width: 20vw;
  height: 12vh;
  font-family: 'Open Sans';
}
.rolemanage-edit >>> .v-data-table__wrapper {
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>
